module.exports = __webpack_public_path__ + "img/vue1-corpsavant_noir.9adb229a.png";